import React from 'react'

import { Link } from 'gatsby'

import { FaArrowLeft } from "react-icons/fa";
import eye from '../images/icon-tiny.png'

const Header = ({ backBtn }) => {
    return (
        <div className="level my-6">
            <div className="level-item">
                <Link to={backBtn ? backBtn : '/'}><FaArrowLeft className="is-size-1 arrow" /></Link>
            </div>
            <div className="level-item">
                <Link to="/"><img src={eye} alt="eye of horus" /></Link>
            </div>
            <div className="level-item" style={{width: '48px'}}>
                {/* space for the sundial (menu) icon. remove width when this is added */}
            </div>
        </div>
    )
}

export default Header
